var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"main-footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"main-footer__nav-wr"},[_c('ul',{staticClass:"main-footer__nav"},_vm._l((_vm.links),function(link,i){return _c('li',{key:i},[(link.href)?_c('router-link',{attrs:{"to":link.href}},[_vm._v(" "+_vm._s(link.label)+" ")]):_vm._e()],1)}),0)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }